/*eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');

import {mapGetters, mapState} from 'vuex';

import toast from '@/services/toast';

export default {
  name: 'course-category',
  components: {},
  props: [],
  data () {
    return {
      courses: {},
      categoryList: {},
      categoryFilterName: '',
      loader: false,
    }
  },
  computed: {
    ...mapGetters([
      'getCategoryList',
      'getProfileInfo'
    ]),
    getUserSubscription(){
        this.userSubscription = this.$store.getters.getProfileInfo
    },
    getCategory(){
       this.categoryList = this.$store.getters.getCategoryList;
    //  console.log(this.$store.getters.getCategoryList);
       return this.categoryList 
    },
    getCourseByCatgoryByActn(){
      this.$store.dispatch('CourseByCategoryAction',{id: this.$route.params.id}).then((response) => {
        if(response.data.code == '2000'){
          this.categoryFilterName = response.data.data.name
        }
      })
    },
    getAllCourses(){ 
      this.loader = true;
      this.$store.dispatch('CourseByCategoryAction', {id: this.$route.params.id }).then((response) => {
        if(response.data.code == '2000'){
          this.loader = false;
            this.courses = this.$store.state.userCourses.couseByCategoryList.courses
            console.log(this.courses)
            return this.courses;
         }
      })
      // return  this.courses = this.$store.getters.lastestcourses.results
    }
  },
  mounted () {
    this.getUserSubscription,
    this.getCategory,
   this.getAllCourses,
   this.getCourseByCatgoryByActn
  },
  methods: {
    enrollcourse(id){
      let data= { course: id }
       this.$store.dispatch('setEnrollNewCourse', data)
       .then((res) => { 
         if(res.data.code == '3017'){
           toast.success(res.data.msg);
           this.$store.dispatch('getcourselist').then((res) => {
            return this.courses = this.$store.state.userCourses.latestCourseState.results;
          }).catch((err) => { 
          });
         }
       })
       .catch((err) => { 
       })
     },
     getCoursebyCategory(id, name){
      this.loader = true;
      if(id != ""){
        this.$router.push('/courses/category/' + id + "/")
        // debugger
        this.$store.dispatch('CourseByCategoryAction', {id: id}).then((response) => {
          if(response.data.code == '2000'){
            this.loader = false;
              this.courses = this.$store.state.userCourses.couseByCategoryList.courses
              return this.courses;
           }
        })
      } else{ 
        this.$store.dispatch('getcourselist').then((res) => {
          this.loader = false;
          this.$router.push('/courses/')
          return this.courses = this.$store.state.userCourses.latestCourseState.results;
        
        }).catch((err) => { 
        });
      }
      this.categoryFilterName = name; 
     },
    //  no_act_subs(id){

    //  }
  },
  watch: {
    getCategory(){
      return this.$store.getters.getCategoryList
    },
    getAllCourses(){
      return this.$store.getters.lastestcourses
    },
    getUserSubscription(){
      return this.$store.getters.getProfileInfo
  },
  }
}
